import { createElement, memo } from '@max/max';
import View from '@hfe/max-view';
import Text from '@hfe/max-text';
import Image from '@hfe/max-image';
import Button from '@hfe/max-button';
import ScrollView from '@hfe/max-scrollview';
import LinearGradient from '@hfe/max-linear-gradient';
import TopView from '@max/leez-top-view';
import ModalBaseContainer from '@max/leez-modal-base-container';
import './index.scss';
const DEFAULT_RULE_TITLE = '绑定规则';
const DEFAULT_TITLE_COLOR = '#1a1a1a';
const CONFIRM_BTN_TEXT = '我知道了';
// 确认按钮底色：红→粉横向渐变（90deg，#ff002a → #fe2b92），Max RN 不支持 CSS 渐变改用 LinearGradient 组件
const CONFIRM_BTN_GRADIENT = ['#ff002a', '#fe2b92'];
function BindingRuleModal(props) {
    const { visible, ruleTitle, ruleTitleColor, ruleText, onClose } = props;
    return <TopView>
      <ModalBaseContainer visible={visible} type="fade" onMaskPress={onClose} maskStyle={{
        opacity: 0.8
    }} maskAnimationIn={{
        opacity: [0, 0.8],
        duration: 300
    }} 
    // 设置蒙层出场动画结束后的透明度为 0
    maskAnimationOut={{
        opacity: [0.8, 0],
        duration: 300
    }}>
        <View className="binding-rule-modal__wrapper">
          <View className="binding-rule-modal__content-wrapper">
            
            <Text className="binding-rule-modal__title" style={{
        color: ruleTitleColor ?? DEFAULT_TITLE_COLOR
    }}>
              {ruleTitle ?? DEFAULT_RULE_TITLE}
            </Text>
            
            <View className="binding-rule-modal__list-wrapper">
              <ScrollView showsVerticalScrollIndicator={false}>
                <View className="binding-rule-modal__scroll-content">
                  <Text className="binding-rule-modal__rule-text">{ruleText ?? ''}</Text>
                  <View className="binding-rule-modal__scroll-footer"/>
                </View>
              </ScrollView>
              <LinearGradient className="binding-rule-modal__bottom-gradient" colors={['#ffffff00', '#ffffffff']} start={{
        x: 0,
        y: 0
    }} end={{
        x: 0,
        y: 1
    }}/>
            </View>
            
            <Button className="binding-rule-modal__confirm-btn" onPress={onClose}>
              <LinearGradient className="binding-rule-modal__confirm-btn-gradient" colors={CONFIRM_BTN_GRADIENT} start={{
        x: 0,
        y: 0
    }} end={{
        x: 1,
        y: 0
    }}/>
              <Text className="binding-rule-modal__confirm-btn-text">{CONFIRM_BTN_TEXT}</Text>
            </Button>
          </View>
          
          <Button className="cfe-five-city-close-button" onPress={() => {
        onClose();
    }}>
            <Image className="cfe-five-city-close-button-img" source={{
        uri: 'https://p0.meituan.net/ingee/dacb6cc62b5d35e0e749fc7a73bbe7821798.png'
    }}/>
          </Button>
        </View>
      </ModalBaseContainer>
    </TopView>;
}
export default memo(BindingRuleModal);
